import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
    View,
    TouchableOpacity,
    StyleSheet
} from 'react-native';

import {
    JDText,
    JDImage,
    JDLogin
} from '@jdreact/jdreact-core-lib';

import { pt, px, tip, success, mta, is_web } from '../../common/utils';
import { get } from '../../common/fetch';
import img from '../../common/img';
import sgmReport from '../../common/sgmUtil';

class PreWantMovieItem extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            movieInfo: props.movieInfo,
            from: props.from
        };
        this.changeWantNum = this.changeWantNum.bind(this);
    }

    render() {
        const { movieInfo, from } = this.props;

        return (
            <View style={ st.movie_item }>
                <View style={ st.movie_item_wrap }>
                    <TouchableOpacity
                        style={ { flexDirection: 'row' } }
                        activeOpacity={ 0.5 }
                        onPress={ () => this.goMovieDetail() }
                    >
                        <JDImage
                            style={ st.item_img }
                            source={ { uri: movieInfo.jdPicUrl } }
                        />
                        <View style={ st.item_info }>
                            <View style={ st.name_type_wrap }>
                                <JDText numberOfLines={ 1 } style={ st.movie_name }>{movieInfo.movieName}</JDText>
                                {!!movieInfo.showType && movieInfo.showType.split('-').length == 1 &&
                                    <View style={ st.movie_type_one_wrap }>
                                        <JDText style={ st.movie_type_one }>{movieInfo.showType}</JDText>
                                    </View>
                                }
                                {!!movieInfo.showType && movieInfo.showType.split('-').length == 2 &&
                                    <View style={ { flexDirection: 'row', height: pt(15), alignItems: 'center' } }>
                                        <JDText style={ st.movie_type_left }>{movieInfo.showType.split('-')[0]}</JDText>
                                        <JDText style={ st.movie_type_right }>{movieInfo.showType.split('-')[1]}</JDText>
                                    </View>
                                }
                            </View>
                            <JDText style={ st.movie_want }>
                                {movieInfo.wannaSeenNum}
                                <JDText style={ st.want_people }>人想看</JDText>
                            </JDText>
                            <JDText numberOfLines={ 1 } style={ st.movie_actor }>主演: {movieInfo.actors ? movieInfo.actors : '未知'}</JDText>
                            <JDText numberOfLines={ 1 } style={ st.movie_plan }>
                                {movieInfo.releaseDate}
                                <JDText style={ { fontSize: pt(10), fontWeight: 'normal' } }>在中国大陆上映</JDText>
                            </JDText>
                        </View>
                    </TouchableOpacity>
                    {movieInfo.canPreOrder === 1 &&
                        <TouchableOpacity style={ st.go_buy } onPress={ () => this.goBuy(movieInfo.movieId, movieInfo.jSkuId) }>
                            <JDImage style={ st.movie_item_goBuy } source={ img.preSale } />
                            <View style={ st.yu_shou_wrap }>
                                <JDText style={ st.yu_shou }>预售</JDText>
                            </View>
                        </TouchableOpacity>
                    }
                    {movieInfo.canPreOrder === 3 && from !== 'search' &&
                        <TouchableOpacity style={ st.go_buy } onPress={ this.changeWantNum }>
                            <JDImage style={ st.movie_item_goBuy } source={ img.wantSee } />
                            <View style={ st.yu_shou_wrap }>
                                <JDText style={ st.yu_shou }>{movieInfo.operType == -1 ? '想看' : movieInfo.operType == 10 ? '已想看' : '想看'}</JDText>
                            </View>
                        </TouchableOpacity>
                    }
                </View>
            </View>
        );
    }

    goMovieDetail() {
        const { movieInfo } = this.props;

        const { movieId, jSkuId, weight, showType, wannaSeenNum } = movieInfo;

        const { from, saveWordAndJump } = this.props;

        if (from === 'search') {
            mta('SearchListItem', 'Search', `${jSkuId}_${movieId}`);
            if (saveWordAndJump) {
                saveWordAndJump(movieInfo, 'detail');

                return;
            }
        }

        if (from === 'allMovie') {
            mta('ListMovPic', 'MovList', `${jSkuId}_${movieId}_${weight}`);
        }

        if (from === 'index') {
            mta('HomeComingPic', 'Home', `${jSkuId}_${movieId}_${showType || ''}_${weight}_${wannaSeenNum}`);
        }
        this.context.router.toMovieDetail({ movieId });
        // }
    }

    goBuy(movieId, sku) {
        const { movieInfo } = this.props;

        const { from, saveWordAndJump } = this.props;

        if (from === 'search') {
            mta('SearchListItem', 'Search', `${sku}_${movieId}`);
            if (saveWordAndJump) {
                saveWordAndJump(movieInfo, 'buy');

                return;
            }
        }
        if (from === 'allMovie') {
            mta('ListMovBuy', 'MovList', '预售');
        }

        if (from === 'index') {
            mta('HomePreSale', 'Home', '预售');
        }

        this.context.router.toMovieSchedule({ movieId });
    }

    changeWantNum() {
        const { wantSee, reloadMovie } = this.props;

        const movieInfo = Object.assign({}, this.props.movieInfo);

        const { movieId, jSkuId, weight, operType, releaseDate } = movieInfo;

        JDLogin.isLogin().then(() => {
            mta('HomeWantToSee', 'Home', `${jSkuId}_${movieId}_${operType == -1 ? '想看' : '已想看'}_${weight}_${releaseDate}`);
            get('userWannaSeeOrScore', { operType: movieInfo.operType == -1 ? 10 : -1, movieId: movieInfo.movieId }, true).then((res) => {
                reloadMovie();
                setTimeout(() => {
                    if (movieInfo.operType == -1) {
                        success('已想看');
                    } else {
                        success('已取消想看');
                    }
                }, 100);
            }, () => {
                movieInfo.operType == -1 ? tip('标记想看失败!') : tip('取消想看失败!');
            });

            if(!movieInfo.movieId){
                sgmReport('1001', {function_id: 'userWannaSeeOrScore',message:'缺少参数movieId'}, 3)
            }

        }, () => {
            JDLogin.doLogin().then(() => {
                wantSee();
            });
        });
    }
}

PreWantMovieItem.contextTypes = {
    router: PropTypes.object
};

const st = StyleSheet.create({
    movie_item: {
        paddingTop: pt(14),
        paddingLeft: pt(15),
        paddingRight: pt(10),
        backgroundColor: '#fff'
    },
    movie_item_wrap: {
        paddingBottom: pt(14),
        borderBottomWidth: px(1),
        borderBottomColor: 'rgba(0,0,0,0.1)',
        flexDirection: 'row'
    },
    item_img: {
        height: pt(88),
        width: pt(60),
        borderRadius: pt(3)
    },
    item_info: {
        width: pt(220),
        marginLeft: pt(14),
        justifyContent: 'space-between',
        paddingVertical: pt(4)
    },
    name_type_wrap: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    movie_name: {
        fontSize: pt(14),
        fontWeight: 'bold',
        marginRight: pt(8),
        maxWidth: pt(180)
    },
    movie_type_one_wrap: {
        paddingHorizontal: pt(3),
        borderRadius: pt(3),
        backgroundColor: '#898989'
    },
    movie_type_one: {
        fontSize: pt(11),
        color: '#fff',
        backgroundColor: 'transparent'
    },
    movie_type_left: {
        height: pt(15),
        fontSize: pt(11),
        paddingHorizontal: pt(3),
        borderTopLeftRadius: pt(3),
        borderBottomLeftRadius: pt(3),
        color: '#fff',
        backgroundColor: '#898989'
    },
    movie_type_right: {
        height: pt(15),
        fontSize: pt(11),
        paddingHorizontal: pt(3),
        color: '#898989',
        backgroundColor: '#fff',
        borderTopRightRadius: pt(3),
        borderBottomRightRadius: pt(3),
        borderWidth: 1,
        borderColor: '#979797'
    },
    movie_want: {
        color: '#FFAE18',
        fontSize: pt(14),
        fontWeight: 'bold'
    },
    want_people: {
        color: '#898989',
        fontSize: pt(10),
        fontWeight: 'normal'
    },
    movie_actor: {
        color: '#666',
        fontSize: pt(12)
    },
    movie_plan: {
        color: '#898989',
        fontSize: pt(11),
        fontWeight: 'bold'
    },
    go_buy: {
        position: 'relative',
        marginTop: pt(6),
        height: pt(30),
        justifyContent: 'center',
        alignItems: 'center'
    },
    movie_item_goBuy: {
        width: pt(52),
        height: pt(26)
    },
    yu_shou_wrap: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        top: 0,
        left: 0,
        justifyContent: 'center',
        alignItems: 'center'
    },
    yu_shou: {
        color: '#fff',
        fontSize: pt(13),
        backgroundColor: 'transparent'
    }
});

export default PreWantMovieItem;
